// extracted by mini-css-extract-plugin
export var aircallIframe = "_fu-3";
export var fabContainer = "_fu-5";
export var fabRinging = "_fu-6";
export var loadingOverlay = "_fu-4";
export var pulse = "_fu-7";
export var widgetContent = "_fu-2";
export var widgetPanel = "_fu-0";
export var widgetPanelExpanded = "_fu-1";